import { store } from '../../../../../resources/frontend/js/store';
import { validateValue } from '../../../js/vue-flows/default-components/sb-validate/v2/validate';
import { preValidateInvalid, preValidateNoStores, preValidateValid } from './mixins/pre-validate';
import allReplace from '../../../mixins/utils/all-replace';

export const setStoreLocator = () => {
    const storeLocator = store.state.storeLocator;

    if (!storeLocator.url) return;

    if (storeLocator.stores.length === 0) {
        getStoreLocatorData();
    }
};

export const getStoreLocatorData = () => {
    const storeLocator = store.state.storeLocator;

    fetch(storeLocator.url)
        .then(response => response.json())
        .then(data => {
            storeLocator.translations = data.lang;
            storeLocator.limit = data.limit * 1;
            storeLocator.homeVisitLimit = data.limitHomeVisits * 1;
            storeLocator.stores = data.branchData || [];

            if (!data.lang) {
                fillStoreLocatorTranslations();
            }

            if (storeLocator.placeholder === '') {
                storeLocator.placeholder = storeLocator.translations.pleaseFillDetails;
            }
        });
};

export const storeLocatorCheck = async () => {
    const storeLocator = store.state.storeLocator;

    if (storeLocator.id === '') return;

    store.commit('form/setFieldData', { name: 'storelocator', key: 'value', value: '' });

    const zipcode = store.state.user.location.zipcode;

    if (validateValue(zipcode, 'zipcode') || (store.state.user.location.latitude && store.state.user.location.longitude)) {
        storeLocator.storesLatLng = [];

        if (!storeLocator.running) {
            storeLocator.running = true;
            storeLocator.runOnBlur = false;

            await checkLocation();
        }
    } else {
        storeLocator.placeholder = storeLocator.translations.pleaseFillDetails;
        storeLocator.completeStoreData = [];
        storeLocator.storeOptions = [];
        storeLocator.homeVisitOptions = [];
        storeLocator.runOnBlur = true;
        preValidateInvalid();
    }
};

export const checkLocation = async () => {
    const storeLocator = store.state.storeLocator;
    const location = store.state.user.location;

    if (location.zipcode) {
        location.zipcode = allReplace(location.zipcode, {
            '０': '0',
            '１': '1',
            '２': '2',
            '３': '3',
            '４': '4',
            '５': '5',
            '６': '6',
            '７': '7',
            '８': '8',
            '９': '9',
        });
        location.zipcode = location.zipcode.replace(' ', '');
    }

    storeLocator.placeholder = storeLocator.translations.oneMomentPlease;
    storeLocator.options = [];

    return await fetch(`/api/store-locator-with-location/${storeLocator.id}?` + new URLSearchParams({
        ...location,
    }))
        .then(response => response.json())
        .then(data => {
            storeLocator.running = false;

            if (
                (storeLocator.showExtraDropdown === 'no_match' || storeLocator.showExtraDropdown === 'always')
                && (data.statusCode === 'NO_BRANCH_CLOSE_BY' || data.statusCode === 'NO_ROUTE_FOUND')
            ) {
                storeLocator.placeholder = storeLocator.translations.pleaseSelectBranch;

                if (storeLocator.showExtraDropdown === 'no_match') {
                    storeLocator.storeOptions.push({
                        value: storeLocator.extraDropdownText,
                        text: storeLocator.extraDropdownText,
                        key: storeLocator.extraDropdownText,
                    });
                }

                preValidateValid();

                return { success: true };
            }

            if (data.statusCode === 'NO_BRANCH_CLOSE_BY') {
                storeLocator.placeholder = storeLocator.translations.noBranchCloseBy;
                preValidateNoStores();
                return { success: false };
            }

            if (data.statusCode === 'NO_ROUTE_FOUND') {
                storeLocator.placeholder = storeLocator.translations.noRouteFound;
                preValidateInvalid();
                return { success: false };
            }

            preValidateValid();

            storeLocator.type === 'custom'
                ? storeLocator.completeStoreData = data
                : storeLocator.completeStoreData = data.results;

            createDropdownOptions(storeLocator.completeStoreData);

            if (storeLocator.prefillStore) prefillStore();

            return { success: true };
        });
};

export const createDropdownOptions = stores => {
    const storeLocator = store.state.storeLocator;

    storeLocator.placeholder = storeLocator.translations.pleaseSelectBranch;
    storeLocator.storeOptions = [];
    storeLocator.homeVisitOptions = [];

    let storeCounter = 0;
    let homevisitCounter = 0;
    const homevisitCompanies = [];

    if (storeLocator.type === 'custom') {
        for (const [id, store] of Object.entries(stores)) {
            const { name, fullAddress } = store;

            storeLocator.storeOptions.push({
                value: fullAddress,
                text: name,
                key: id,
            });

            storeLocator.completeStoreData[id].storeKey = id;
        }

        return;
    }

    stores.forEach(store => {
        const value = store.dropdownValue;
        const key = store.storeKey;
        const type = store.type;
        const distance = store.distance;
        const travelDistance = store.travelDistance;

        let text = value;

        if (storeLocator.proximityDisplay === 'time') {
            let time = Math.round(store.time / 60);
            time = (time < 10) ? ('0' + time) : time;
            text = `[${time}${storeLocator.translations.minute}] ${value}`;
        } else if (storeLocator.proximityDisplay === 'distance') {
            let distanceValue = Math.round(travelDistance / 1000);
            distanceValue = (distanceValue < 10) ? ('0' + distanceValue) : distanceValue;
            text = `[${distanceValue}${storeLocator.translations.distance || 'km'}] ${value}`;
        }

        switch (storeLocator.showExtraData) {
            case 'address':
                text += `, ${store.address}`;
                break;
            case 'city':
                text += `, ${store.city}`;
                break;
            case 'address_and_city':
                text += `, ${store.address}, ${store.city}`;
                break;
        }

        // Fill stores
        if (type === 'store') {
            if (storeCounter < 3 && distance < storeLocator.limit) {
                storeLocator.storeOptions.push({
                    value,
                    text,
                    key,
                });

                storeCounter++;
            }
        }

        // Fill home visits
        if (type === 'home_visit') {
            if (!homevisitCompanies.includes(value) && homevisitCounter < 3 && distance < storeLocator.limitHomeVisits) {
                homevisitCompanies.push(value);

                storeLocator.homeVisitOptions.push({
                    value,
                    text: value,
                    key,
                });

                homevisitCounter++;
            }
        }
    });
};

export const fillStoreLocatorTranslations = () => {
    const storeLocator = store.state.storeLocator;
    const translations = store.state.page.translations['store-locator'];

    storeLocator.translations = {};
    storeLocator.translations.homeVisit = translations.HOME_VISIT;
    storeLocator.translations.minute = translations.MINUTE;
    storeLocator.translations.noBranchCloseBy = translations.NO_BRANCH_CLOSE_BY;
    storeLocator.translations.noRouteFound = translations.NO_ROUTE_FOUND;
    storeLocator.translations.oneMomentPlease = translations.ONE_MOMENT_PLEASE;
    storeLocator.translations.pleaseFillDetails = translations.PLEASE_FILL_DETAILS;
    storeLocator.translations.pleaseSelectBranch = translations.PLEASE_SELECT_BRANCH;
    storeLocator.translations.visitStore = translations.VISIT_STORE;
    storeLocator.translations.prefillConfirmation = translations.PREFILL_CONFIRMATION;
};

const handleStorelocatorChange = event => {
    const page = store.state.page;
    const storeLocator = store.state.storeLocator;

    const value = store.getters['form/getFieldData']('value', 'storelocator');

    if (value && event) {
        const option = event.currentTarget.querySelector('option:checked');
        let store = store.getters['storeLocator/getOption'](option.getAttribute('data-key'));
        let time = '';

        if (option.getAttribute('data-key') === storeLocator.extraDropdownText) {
            store = {
                id: '',
                key: '',
                type: '',
                zipcode: '',
            };
        } else {
            time = Math.round(store.time / 60);
            time = (time < 10) ? ('0' + time) : time;
        }

        store.commit('form/setFieldData', { name: 'storelocator-id', key: 'value', value: store.id });

        if (store.key) {
            store.commit('form/setFieldData', { name: 'storelocator-key', key: 'value', value: store.key });
        }

        if (store.dealership && page.isFccSubject) {
            store.commit('form/setFieldData', { name: 'storelocator-dealership', key: 'value', value: store.dealership });
            store.commit('page/setVariable', { key: 'dealership', value: store.dealership });
        }

        store.commit('form/setFieldData', { name: 'storelocator-time', key: 'value', value: time });

        store.commit('form/setFieldData', { name: 'storelocator-type', key: 'value', value: store.type });
        store.commit('form/setFieldData', { name: 'storelocator-zipcode', key: 'value', value: store.zipcode });
    }
};

const storelocatorInitialize = () => {
    if (!store.getters['form/fieldExists']('storelocator-time')) {
        const fields = [
            'storelocator-time',
            'storelocator-zipcode',
            'storelocator-key',
            'storelocator-dealership',
            'storelocator-type',
            'storelocator-id',
        ];

        for (const field of fields) {
            store.commit('form/addField', {
                name: field,
                data: {
                    value: 'unknown',
                },
            });
        }
    }

    if (
        (store.state.user.location.zipcode && validateValue(store.state.user.location.zipcode, 'zipcode'))
        || (store.state.user.location.latitude && store.state.user.location.longitude)
    ) {
        checkLocation();
    }
};

export const prefillStore = () => {
    const page = store.state.page;
    const storeLocator = store.state.storeLocator;
    const storeOption = storeLocator.storeOptions[0];
    let storeObject;

    if (storeLocator.type === 'custom') {
        storeObject = storeLocator.completeStoreData[storeOption.key];
    } else {
        storeObject = storeLocator.completeStoreData.find(store => store.storeKey === storeOption.key);
    }

    if (storeObject) {
        let time = Math.round(storeObject.time / 60);
        time = (time < 10) ? ('0' + time) : time;

        store.commit('form/setFieldData', { name: 'storelocator', key: 'value', value: storeOption.value });

        store.commit('form/setFieldData', { name: 'storelocator-id', key: 'value', value: storeObject.id });

        if (storeObject.key) {
            store.commit('form/setFieldData', { name: 'storelocator-key', key: 'value', value: storeObject.key });
        }

        if (storeObject.dealership && page.isFccSubject) {
            store.commit('form/setFieldData', { name: 'storelocator-dealership', key: 'value', value: storeObject.dealership });
            store.commit('page/setVariable', { key: 'dealership', value: storeObject.dealership });
        }

        store.commit('form/setFieldData', { name: 'storelocator-time', key: 'value', value: time });

        store.commit('form/setFieldData', { name: 'storelocator-type', key: 'value', value: storeObject.type });
        store.commit('form/setFieldData', { name: 'storelocator-zipcode', key: 'value', value: storeObject.zipcode });
    }
};
